import {parseNumber, twMerge} from '@sdox/utils'

import {AnimatedCount} from '../../'

import type {KpiItemBaseProps} from './Kpi.Item'
import type {ReactNode} from 'react'

const Value = ({value, variant}: Pick<KpiItemBaseProps, 'value' | 'variant'>) => {
  let content: ReactNode = value

  if (typeof value === 'number' && typeof variant === 'string') {
    content = (
      <AnimatedCount
        value={value}
        direction={variant}
        transformFn={parseNumber}
      />
    )
  }

  return (
    <label className={'line-clamp-1 text-d1 text-glyph-default-primary'}>
      {content}
    </label>
  )
}
const Unit = ({unit}: Pick<KpiItemBaseProps, 'unit'>) => (
  <label className={'line-clamp-1 text-p1 text-glyph-default-primary'}>
    {unit}
  </label>
)

const Label = ({title}: Pick<KpiItemBaseProps, 'title'>) => (
  <label className={'text-p1 text-glyph-default-primary'}>
    {title}
  </label>
)

const Description = ({subtitle}: Pick<KpiItemBaseProps, 'subtitle'>) => (
  <label className={'text-p1 text-glyph-default-secondary'}>
    {subtitle}
  </label>
)

/**
 * KpiItemUnderline component
 * shows information with a large text value with unit side by side.
 * the title and subtitle are rather smaller, positioned at the bottom.
 */
export const KpiItemUnderline = ({title = '', value, unit, subtitle = '', className, variant, ...restProps}: KpiItemBaseProps) => (
  <div
    className={twMerge('flex flex-col', className)}
    {...restProps}
  >
    <div className={'flex flex-row items-baseline gap-spacing-4 border-b-1 border-outline-secondary pb-spacing-16'}>
      <Value
        value={value}
        variant={variant}
      />
      {unit ? <Unit unit={unit} /> : null}
    </div>
    {title || subtitle ? (
      <div className={'mr-spacing-16 mt-spacing-12 flex flex-col items-start'}>
        {title ? <Label title={title} /> : null}
        {subtitle ? <Description subtitle={subtitle} /> : null}
      </div>
    ) : null}
  </div>
)
